import VueBaseController from '../../vue_base'

// eslint-disable-next-line import/prefer-default-export
export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/admin/link_building/proxies/index.vue') }
}
